<template>
    <div class="photograph-container">
        <el-form inline :model="form" ref="form" label-width="90px" class="camera-form">
            <el-form-item label="摄像头" prop="photograph">
                <el-select v-model="form.photograph" placeholder="请选择摄像头" class="camera-select">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="纸张规格">
                <el-radio-group v-model="paperSize" size="small">
                    <el-radio-button label="A5">A5</el-radio-button>
                    <el-radio-button label="A4">A4</el-radio-button>
                    <el-radio-button label="A3">A3</el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="方向">
                <el-radio-group v-model="paperOrientation" size="small">
                    <el-radio-button label="portrait">纵向</el-radio-button>
                    <el-radio-button label="landscape">横向</el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-camera" @click="cameraClick">拍照</el-button>
                <!-- <el-button type="warning" icon="el-icon-crop" @click="applyPaperCrop" :disabled="!pictureUrl">按纸张裁剪</el-button> -->
                <el-button type="success" icon="el-icon-upload2" @click="cameraSubmit" :disabled="!pictureUrl">上传</el-button>
            </el-form-item>
        </el-form>
        
        <div class="content-wrapper">
            <!-- 预览区域 -->
            <div class="preview-section">
                <div class="preview-title">拍照预览</div>
                <div class="preview-box" v-if="!pictureUrl">
                    <i class="el-icon-camera-solid camera-icon"></i>
                    <p class="preview-tip">点击"拍照"按钮开始拍摄</p>
                </div>
                <div class="preview-image" v-else>
                    <el-image 
                        class="image-preview" 
                        :src="pictureUrl" 
                        fit="contain" 
                        :preview-src-list="[pictureUrl]"
                    >
                        <div slot="error" class="image-error">
                            <i class="el-icon-picture-outline"></i>
                            <span>加载失败</span>
                        </div>
                    </el-image>
                </div>
            </div>

            <!-- 图片列表区域 -->
            <div class="image-list-section">
                <div class="list-header">
                    <span class="list-title">已上传图片</span>
                    <span class="list-count">{{ imgList.length }} 张</span>
                </div>
                <ul class="image-list" v-if="imgList.length > 0">
                    <li v-for="(item, index) in imgList" :key="index" class="image-item">
                        <div class="image-wrapper">
                            <el-image 
                                :ref="`image-${index}`"
                                class="thumbnail" 
                                :src="`${imgUrl}/${item.fileUrl}`" 
                                fit="cover" 
                                :preview-src-list="imgList.map(img => `${imgUrl}/${img.fileUrl}`)"
                                :initial-index="index"
                            >
                                <div slot="error" class="image-error-small">
                                    <i class="el-icon-picture-outline"></i>
                                </div>
                            </el-image>
                            <div class="image-mask" @click.stop>
                                <div class="mask-actions">
                                    <i class="el-icon-zoom-in" @click="previewImage(index)" title="预览图片"></i>
                                    <i class="el-icon-delete" @click="delClick(index)" title="删除图片"></i>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <div v-else class="empty-list">
                    <i class="el-icon-picture-outline"></i>
                    <p>暂无图片</p>
                </div>
            </div>
        </div>

        <!-- 底部操作栏 -->
        <div class="footer-actions">
            <el-button size="small" @click="closeClick">取消</el-button>
            <el-button size="small" type="primary" @click="openClick" :disabled="imgList.length === 0">
                保存 ({{ imgList.length }})
            </el-button>
        </div>
    </div>
</template>

<script>
import {
    upFile,
} from "@/service/printApi.js";
import axios from 'axios'
export default {
    name: 'photograph',
    data() {
        return {
            form: {
                photograph: ''
            },
            pictureUrl: '',
            options: [],
            imgList: [],
            imgUrl: "",
            previewSrcList: [],
            /** ISO 216 纸张：与打印规格对应，输出按 DPI 缩放 */
            paperSize: 'A4',
            paperOrientation: 'portrait',
            paperExportDpi: 150
        }
    },
    created() {
        if (localStorage.getItem('photograph')) {
            this.form.photograph = localStorage.getItem('photograph');
        } else {
            this.form.photograph = "";
        }
        this.imgUrl = window.global_config.BASE_IMG_URL
        this.init()
    },
    methods: {
        init() {
            axios.get(`${window.global_config.GPY_URL}/api/cameras`).then((res) => {
                console.log(res)
                if (res.data.cameras.length > 0) {
                    this.options = res.data.cameras.map(item => ({
                        value: item,
                        label: item
                    }))
                }
            }).catch((error) => {
                console.error('获取摄像头列表失败:', error)
                this.$message.warning('获取摄像头列表失败')
            })
        },
        cameraClick() {
            if (!this.form.photograph) {
                this.$message.warning('请先选择摄像头')
                return
            }
            const loading = this.$loading({
                lock: true,
                text: '正在拍照...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            axios.get(`${window.global_config.GPY_URL}/api/capture`, {
                responseType: 'blob'
            }).then((res) => {
                const blob = res.data
                const reader = new FileReader()
                reader.onload = (e) => {
                    this.pictureUrl = e.target.result
                    this.applyPaperCrop()
                }
                reader.readAsDataURL(blob)
            }).catch((error) => {
                console.error('拍照失败:', error)
                this.$message.error('拍照失败，请重试')
            }).finally(() => {
                loading.close()
            })
        },
        /** A5/A4/A3 宽×高（mm，纵向），ISO 216 */
        getPaperMm(size, portrait) {
            const mm = {
                A5: [148, 210],
                A4: [210, 297],
                A3: [297, 420]
            }
            const [shortMm, longMm] = mm[size] || mm.A4
            return portrait
                ? { wMm: shortMm, hMm: longMm }
                : { wMm: longMm, hMm: shortMm }
        },
        getPaperPixels(size, portrait) {
            const { wMm, hMm } = this.getPaperMm(size, portrait)
            const dpi = this.paperExportDpi
            return {
                w: Math.max(1, Math.round((wMm / 25.4) * dpi)),
                h: Math.max(1, Math.round((hMm / 25.4) * dpi))
            }
        },
        applyPaperCrop() {
            if (!this.pictureUrl) {
                this.$message.warning('请先拍照')
                return
            }
            const portrait = this.paperOrientation === 'portrait'
            const { w: outW, h: outH } = this.getPaperPixels(this.paperSize, portrait)
            const aspect = outW / outH
            const img = new Image()
            img.onload = () => {
                const iw = img.naturalWidth
                const ih = img.naturalHeight
                if (!iw || !ih) {
                    this.$message.error('无法读取图片尺寸')
                    return
                }
                const imgAspect = iw / ih
                let sx
                let sy
                let sw
                let sh
                if (imgAspect > aspect) {
                    sh = ih
                    sw = Math.round(ih * aspect)
                    sx = Math.round((iw - sw) / 2)
                    sy = 0
                } else {
                    sw = iw
                    sh = Math.round(iw / aspect)
                    sx = 0
                    sy = Math.round((ih - sh) / 2)
                }
                const canvas = document.createElement('canvas')
                canvas.width = outW
                canvas.height = outH
                const ctx = canvas.getContext('2d')
                if (!ctx) {
                    this.$message.error('拍照失败')
                    return
                }
                ctx.imageSmoothingEnabled = true
                ctx.imageSmoothingQuality = 'high'
                ctx.drawImage(img, sx, sy, sw, sh, 0, 0, outW, outH)
                this.pictureUrl = canvas.toDataURL('image/jpeg', 0.92)
                this.$message.success(`已按 ${this.paperSize}（${portrait ? '纵向' : '横向'}）拍照成功`)
            }
            img.onerror = () => {
                this.$message.error('图片加载失败，无法裁剪')
            }
            img.src = this.pictureUrl
        },
        cameraSubmit() {
            if (!this.pictureUrl) {
                this.$message.warning('请先拍照')
                return
            }
            const loading = this.$loading({
                lock: true,
                text: '正在上传...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            const token = sessionStorage.getItem("token")
            const arr = this.pictureUrl.split(',')
            const mime = arr[0].match(/:(.*?);/)[1]
            const bstr = atob(arr[1])
            let n = bstr.length
            const u8arr = new Uint8Array(n)
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n)
            }
            const timestamp = (new Date()).valueOf()
            const formData = new FormData()
            const file = new File([u8arr], timestamp + '.jpeg', { type: mime })
            formData.append('file', file)
            
            upFile(formData, token).then((res) => {
                if (res.status === 200) {
                    this.imgList.push({
                        ...res.result[0]
                    })
                    this.pictureUrl = ''
                    this.$message.success('上传成功')
                }
            }).catch((error) => {
                console.error('上传失败:', error)
                this.$message.error('上传失败，请重试')
            }).finally(() => {
                loading.close()
            })
        },
        delClick(index) {
            this.$confirm('确定要删除这张图片吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.imgList.splice(index, 1)
                this.$message.success('删除成功')
            }).catch(() => {})
        },
        previewImage(index) {
            // 通过ref获取对应的el-image组件并触发预览
            const imageRef = this.$refs[`image-${index}`]
            if (imageRef && imageRef[0]) {
                imageRef[0].clickHandler()
            }
        },
        closeClick() {
            this.$emit('submit')
        },
        openClick() {
            if (this.imgList.length === 0) {
                this.$message.warning('请至少上传一张图片')
                return
            }
            this.$emit('submit', this.imgList)
        }
    }
}
</script>

<style scoped>
/* 主题色定义 */
:root {
    --primary-color: #409EFF;
    --success-color: #67C23A;
    --warning-color: #E6A23C;
    --danger-color: #F56C6C;
    --info-color: #909399;
    --border-color: #DCDFE6;
    --bg-color: #F5F7FA;
    --text-primary: #303133;
    --text-regular: #606266;
    --text-secondary: #909399;
}

.photograph-container {
    padding: 20px;
    background: #fff;
    border-radius: 8px;
}

/* 表单样式 */
.camera-form {
    margin-bottom: 20px;
    padding: 15px;
    background: linear-gradient(135deg, #f5f7fa 0%, #e8eef5 100%);
    border-radius: 8px;
    border: 1px solid var(--border-color);
}

.camera-select {
    width: 200px;
}

/* 内容区域 */
.content-wrapper {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
}

/* 预览区域 */
.preview-section {
    flex-shrink: 0;
}

.preview-title {
    font-size: 14px;
    font-weight: 600;
    color: var(--text-primary);
    margin-bottom: 10px;
    padding-left: 10px;
    border-left: 3px solid var(--primary-color);
}

.preview-box {
    width: 320px;
    height: 320px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
    transition: all 0.3s ease;
}

.preview-box:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
}

.camera-icon {
    color: #fff;
    font-size: 80px;
    margin-bottom: 15px;
    animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
    0%, 100% {
        opacity: 1;
        transform: scale(1);
    }
    50% {
        opacity: 0.8;
        transform: scale(1.05);
    }
}

.preview-tip {
    color: #fff;
    font-size: 14px;
    margin: 0;
    opacity: 0.9;
}

.preview-image {
    width: 320px;
    height: 320px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border: 2px solid var(--primary-color);
}

.image-preview {
    width: 100%;
    height: 100%;
}

/* 图片列表区域 */
.image-list-section {
    flex: 1;
    min-width: 0;
}

.list-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    padding: 0 10px;
}

.list-title {
    font-size: 14px;
    font-weight: 600;
    color: var(--text-primary);
    padding-left: 10px;
    border-left: 3px solid var(--success-color);
}

.list-count {
    font-size: 12px;
    color: var(--text-secondary);
    background: var(--bg-color);
    padding: 4px 12px;
    border-radius: 12px;
}

.image-list {
    list-style: none;
    padding: 15px;
    margin: 0;
    min-height: 320px;
    max-height: 320px;
    overflow-y: auto;
    background: var(--bg-color);
    border-radius: 8px;
    border: 1px solid var(--border-color);
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    align-content: flex-start;
}

.image-list::-webkit-scrollbar {
    width: 6px;
}

.image-list::-webkit-scrollbar-thumb {
    background: var(--border-color);
    border-radius: 3px;
}

.image-list::-webkit-scrollbar-thumb:hover {
    background: var(--text-secondary);
}

.image-item {
    width: 110px;
    height: 110px;
    border-radius: 8px;
    overflow: hidden;
    transition: all 0.3s ease;
}

.image-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    cursor: pointer;
}

.image-wrapper:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.thumbnail {
    width: 100%;
    height: 100%;
}

.image-mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
}

.image-wrapper:hover .image-mask {
    opacity: 1;
}

.mask-actions {
    display: flex;
    gap: 15px;
    align-items: center;
    justify-content: center;
}

.image-mask i {
    color: #fff;
    font-size: 24px;
    cursor: pointer;
    transition: all 0.3s ease;
    padding: 10px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.3);
    pointer-events: auto;
}

.image-mask i:hover {
    transform: scale(1.2);
    background: rgba(0, 0, 0, 0.6);
}

.image-mask .el-icon-zoom-in:hover {
    color: var(--primary-color);
    background: rgba(64, 158, 255, 0.2);
}

.image-mask .el-icon-delete:hover {
    color: var(--danger-color);
    background: rgba(245, 108, 108, 0.2);
}

.empty-list {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 320px;
    color: var(--text-secondary);
}

.empty-list i {
    font-size: 60px;
    margin-bottom: 10px;
    opacity: 0.5;
}

.empty-list p {
    margin: 0;
    font-size: 14px;
}

.image-error,
.image-error-small {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    background: var(--bg-color);
    color: var(--text-secondary);
}

.image-error i {
    font-size: 40px;
    margin-bottom: 8px;
}

.image-error-small i {
    font-size: 30px;
}

/* 底部操作栏 */
.footer-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    padding-top: 20px;
    border-top: 1px solid var(--border-color);
}

/* 响应式设计 */
@media (max-width: 768px) {
    .content-wrapper {
        flex-direction: column;
    }
    
    .preview-box,
    .preview-image {
        width: 100%;
        max-width: 320px;
        margin: 0 auto;
    }
    
    .image-list {
        max-height: 200px;
    }
}
</style>